import {
  GoabButton,
  GoabButtonGroup,
  GoabPageBlock,
  GoabSpacer,
  GoabBadge,
  GoabGrid
} from "@abgov/react-components";
import { useLogin } from "../../hooks/useLogin";
import DisplayContent from "../../../MPP-Common-SPA/components/DynamicForm/Forms/DisplayContent";
import { FINISH_LATER_FORM_ID } from "../../../MPP-Common-SPA/utils/globalUtility";
import { DynamicFields } from "../../../MPP-Common-SPA/components/DynamicForm/Forms/DynamicFields";
import { tryParse } from "../../../MPP-Common-SPA/utils/globalUtility";
import { getProgramEventNameByCode } from '../../../MPP-Common-SPA/utils/getProgramEventNameByCode';
import { constants } from "../../../MPP-Common-SPA/common/constants/statuses";

const FinishLaterConfirmation = ({
  applicationType,
  user,
  getResourceValue,
  moveBackToApp,
  getDynamicForm,
  getRefData,
  userApplicationData,
  programEvents,
}) => {

  const { email } = user;
  const { handleLogout } = useLogin();

  const clickHandlers = {
    "handleLogout": handleLogout,
    "moveBackToApp": moveBackToApp
  };

  const form = tryParse(getDynamicForm(FINISH_LATER_FORM_ID, true)?.template);

  const applicationTypeName = getProgramEventNameByCode(programEvents, applicationType);

  const context = { email, code: userApplicationData?.uniqueApplicationCode, applicationTypeName, ...constants, user };

  if (form?.fields) {
    return  (
      <DynamicFields
        children={form.fields}
        getResourceValue={getResourceValue}
        getRefData={getRefData}
        clickHandlers={clickHandlers}
        context={context}>
      </DynamicFields>
    );
  }

  return (
    <GoabPageBlock width="704px">
      <GoabSpacer vSpacing="2xl" />
      <h1>
        {getResourceValue({ key: "RESOURCES@saveAndFinishLater.button.finishLater" })}
      </h1>
      <GoabSpacer vSpacing="m" />
      <GoabGrid minChildWidth="320px">
        <GoabBadge
          type="information"
          content={applicationTypeName}
        ></GoabBadge>
        <DisplayContent
          content={getResourceValue({ key: "RESOURCES@global.applicationCode", params: { uniqueApplicationCode: userApplicationData.uniqueApplicationCode } })}
        />
      </GoabGrid>
      <div style={{ overflowWrap: "break-word" }}>
        <GoabSpacer vSpacing="2xl" />
        <DisplayContent
          content={getResourceValue({
            key: "RESOURCES@global.finishLater.description",
            params: {
              email,
            },
          })}
        />
      </div>
      <GoabSpacer vSpacing="2xl" />
      <GoabButtonGroup>
        <GoabButton type="primary" onClick={handleLogout}>
          {getResourceValue({ key: "RESOURCES@global.button.signout" })}          
        </GoabButton>

        <GoabButton type="tertiary" testId="next-btn" onClick={moveBackToApp}>
          {getResourceValue({
            key: "RESOURCES@global.button.backToApplication",
          })}
        </GoabButton>
      </GoabButtonGroup>

      <GoabSpacer vSpacing="l" />
    </GoabPageBlock>
  );
};

export default FinishLaterConfirmation;
